import React from 'react'
import Constant from '../../Constant'
import FaqCom from './FaqCom'
import { motion } from 'framer-motion'
import AccordionCard from './AccordionCard'
import '../../../src/index.css'

function Faq() {
  return (
      <div className="fade-in mt-16 px-6 sm:px-24">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
          className="my-7 text-[24px] sm:text-[44px] text-center text-text-color1"
        >
          Frequently asked <span className={Constant.linearColor}>questions</span>
        </motion.h1>

        <div className="main-component">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={{
              hidden: { opacity: 0 },
              show: {
                opacity: 1,
                transition: { staggerChildren: 0.2 },
              },
            }}
            className="-space-y-7 flex flex-col"
          >
            {[
              {
                header: 'What is a non-interest wealth management app?',
                con: 'A non-interest wealth management app helps individuals grow and manage their finances through ethical, Shariah-compliant savings, investments, and asset financing without earning or paying interest (Riba).',
                color: 'bg-[#D5C1FB]',
                textColor: 'text-[#14013A]',
              },
              {
                header: 'How does this app ensure Shariah compliance?',
                con: 'We follow Islamic finance principles by offering only Halal investment options, profit-sharing models, and interest-free asset financing. Our offerings are reviewed and certified by a Shariah advisory board.',
                color: 'bg-[#14013A]',
                textColor: 'text-[#F2F1F3]',
              },
              {
                header: 'Who can use this app?',
                con: "Anyone looking for ethical financial solutions, whether you're an individual, a business, or someone who wants to manage their finances in line with Islamic principles.",
                color: 'bg-[#8BD8B4]',
                textColor: 'text-[#14013A]',
              },
              {
                header: 'How does the savings feature work?',
                con: 'You can deposit money into your Halal savings account and earn profits through ethical investments instead of interest. We pool funds into Shariah-compliant ventures to generate returns.',
                color: 'bg-[#FAB55B]',
                textColor: 'text-[#14013A]',
              },
              {
                header: 'Can I save alone without joining a group?',
                con: 'Absolutely. While we encourage collaborative saving through pods, you can save individually and still benefit from our halal investment tools and ethical structure.',
                color: 'bg-[#14013A]',
                textColor: 'text-[#F2F1F3]',
              },
              {
                header: 'How is my money stored and protected?',
                con: 'Your funds are kept in a secure, licensed financial system. We do not lend your money or invest it in non-halal ventures.',
                color: 'bg-[#8BD8B4]',
                textColor: 'text-[#14013A]',
              },
              {
                header: 'What makes this savings platform halal?',
                con: 'We do not pay or receive interest (riba). Instead, we use halal savings instruments and partnerships vetted by certified Islamic finance scholars. All returns are based on ethical profit-sharing models.',
                color: 'bg-[#FAB55B]',
                textColor: 'text-[#14013A]',
              },
              {
                header: 'Is there a minimum amount I must save?',
                con: 'You can start with as little as ₦1,000. We believe consistency is more powerful than the amount. Build a habit, not pressure.',
                color: 'bg-[#8046F2]',
                textColor: 'text-[#F2F1F3]',
              },
              {
                header: 'Can I automate my savings?',
                con: 'Yes. You can set up automatic deductions (weekly or monthly) so you never miss a deposit.',
                color: 'bg-[#D5C1FB]',
                textColor: 'text-[#14013A]',
              },
              {
                header: 'Can I withdraw anytime?',
                con: 'It depends on your plan. We offer flexible and fixed-term halal savings plans. Some allow withdrawals anytime; others reward you for staying consistent for 3–6 months.',
                color: 'bg-[#14013A]',
                textColor: 'text-[#F2F1F3]',
              },
            ].map((faq, index) => (
              <motion.div
                key={index}
                variants={{
                  hidden: { opacity: 0, y: 40 },
                  show: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
              >
                <AccordionCard
                  header={faq.header}
                  con={faq.con}
                  color={faq.color}
                  textColor={faq.textColor}
                />
              </motion.div>
            ))}

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
              viewport={{ once: true }}
              className="z-50"
            >
              <FaqCom
                color={'bg-[#8046F2]'}
                textColor={'text-[#F2F1F3]'}
                header={'Are my savings secure?'}
                con={
                  'Yes! We partner with regulated financial institutions to ensure your funds are protected, and we only invest in low-risk, ethical opportunities.'
                }
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
  )
}

export default Faq
